export default __webpack_public_path__ + "static/media/image 11.1218494e.svg";